import { createAction } from '@wix/communities-blog-client-common';

export const CLEAR_POSTS = 'posts/CLEAR';

export const clearPosts = createAction(CLEAR_POSTS);
